import Cookies from "js-cookie";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { FetchDataTypes } from "../../api/api";
import {
  currencyFormat,
  formateCurr,
  formateDatabuyCurr,
  formateDataCurr,
} from "../../utils/types";
import { BASE_URL, API_KEY } from "../../api/api"

const FundTransfer = () => {
  const [getData, setGetData] = useState<any>();
  const [selectedParticipant, setSelectedParticipant] = useState();
  const [getBalance, setGetBalance] = useState<any>(null);
  const [toBalance, setToBalance] = useState<any>(null);
  const [filteredSector, setFilteredSector] = useState<any>();
  const [showErrormsg, setShowErrormsg] = useState(false);
  const [amountValue, setAmountValue] = useState("");
  const [notes, setNotes] = useState("");
  const [FirstResponse, setFirstResponse] = useState(false);
  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchDataTypes("RebalanceParticipant", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setGetData(response);
      });
  }, []);

  function handleChangeParticipant(e: any) {
    setSelectedParticipant(e.target.value);
  }
  function handleParticipantFrom(e: any) {
    setGetBalance(e.target.value);
  }
  function handleParticipantTo(e: any) {
    setToBalance(e.target.value);
  }
  const participantList = _.uniqBy(getData, "participantName");
  const participantFrom = _.filter(getData, {
    participantName: selectedParticipant,
  });

  const participantTo = _.filter(
    participantFrom,
    (fund) => fund.fundName !== getBalance
  );

  console.log(participantTo);
  const participantBalance = _.find(participantFrom, { fundName: getBalance });

  function handleAmount(e: any) {
    const amount = e.target.value;
    setAmountValue(e.target.value);
  }

  function handleNotes(e: any) {
    setNotes(e.target.value);
  }

  function handleSubmit(e: any) {
    e.preventDefault();
    var currentTime = new Date();
    var curdate = currentTime.toISOString().slice(0, 10);
    const fromData = _.find(getData, { fundName: getBalance });
    const toData = _.find(getData, { fundName: toBalance });
    const fromPayload = 
      {
        fundID: fromData.fundID,
        notes: notes,
        participantID: fromData.participantID,
        transactionAmount: -parseInt(amountValue),
        transactionCode: "TO",
        transactionDate: curdate,
      }
    
    const toPayload = 
      {
        fundID: toData.fundID,
        notes: notes,
        participantID: toData.participantID,
        transactionAmount: parseInt(amountValue),
        transactionCode: "TI",
        transactionDate: curdate,
      }
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${Cookies.get("newJwt")}`);
    myHeaders.append("Content-Type", "application/json");
    // Make the PUT request to the server
    fetch(`${BASE_URL}/${API_KEY}/api/transactions`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(fromPayload),
    })
      .then((response) => {
        if (response.ok) {
          console.log("Targets updated successfully!");
          setFirstResponse(true);
        } else {
          console.error("Error updating targets:", response.statusText);
          setFirstResponse(false);
        }
      })
      .catch((error) => {
        console.error("Error updating targets:", error);
        setFirstResponse(false);
      });

    if (FirstResponse) {
      fetch(`${BASE_URL}/${API_KEY}/api/transactions`, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(toPayload),
      })
        .then((response) => {
          if (response.ok) {
            console.log("Targets updated successfully!");
          } else {
            console.error("Error updating targets:", response.statusText);
          }
        })
        .catch((error) => {
          console.error("Error updating targets:", error);
        });
    }
    console.log(fromPayload);
    console.log(toPayload);
    setShowErrormsg(true);
  }

  return (
    <div className="mt-4">
      <div className="card mr-2 shadow-none">
        <div className="col-sm-3 w-100 py-3 justify-content-between tableFilters">
          <h5 className="card-title float-start">Fund Transfer</h5>
        </div>
        {showErrormsg && showErrormsg ? (
          // <span className="errorText text-danger position-absolute" style={{top: "46px", fontSize: "14px"}}>
          //   Total Target % should be equal to 100%, Please enter/adjust the New Target %
          // </span>
          <div
            className="alert alert-success alert-dismissible position-absolute statusAlert"
            role="alert"
          >
            <div className="alert-message">Fund Transfer Successfully</div>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
        ) : null}
        <div className="row content-pane">
          <div className="col-12 my-3">
            <form
              id="fundTransferForm"
              className="tradeForm"
              onSubmit={handleSubmit}
            >
              <div className="row">
                <div className="mb-3 col-md-2">
                  <label>Participant</label>
                </div>
                <div className="mb-3 col-md-4 error-placeholder w-25">
                  <select
                    onChange={handleChangeParticipant}
                    className="form-select"
                  >
                    <option value="">Select</option>
                    {participantList &&
                      participantList.map((e: any) => {
                        return (
                          <option
                            value={e.participantName}
                            key={e.participantName}
                          >
                            {e.participantName}
                          </option>
                        );
                      })}
                  </select>
                </div>
                <div className="mb-3 col-md-2 d-flex align-items-center px-6">
                  <label>Balance:</label>
                </div>
                <div className="mb-3 col-md-4 d-flex align-items-center">
                  <strong>
                    {selectedParticipant && getBalance
                      ? `$${participantBalance?.marketValue}`
                      : "$0"}
                  </strong>
                </div>
              </div>
              <div className="row">
                <div className="col-md-2">
                  <label>Fund From</label>
                </div>
                <div className="col-md-4 error-placeholder w-25">
                  <select
                    name="validation-required"
                    id="targetFund"
                    className="form-control"
                    onChange={handleParticipantFrom}
                  >
                    <option value="">Select</option>
                    {participantFrom &&
                      participantFrom.map((e: any) => {
                        return (
                          <option value={e.fundName} key={e.fundID}>
                            {e.fundName}
                          </option>
                        );
                      })}
                  </select>
                </div>

                <div className="col-md-2 px-6">
                  <label>Amount:</label>
                </div>
                <div className="mb-3 col-md-4 error-placeholder">
                  <input
                    name="transactionAmount"
                    type="number"
                    className="form-control secure-input-field w-50"
                    placeholder=""
                    onChange={handleAmount}
                  />
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-md-2">
                  <label>Fund To</label>
                </div>
                <div className="mb-3 col-md-4 error-placeholder w-25">
                  <select
                    name="validation-required"
                    id="targetFund"
                    className="form-control"
                    onChange={handleParticipantTo}
                  >
                    <option value="">Select</option>
                    {participantTo?.map((e: any) => {
                      return (
                        <option value={e.fundName} key={e.fundID}>
                          {e.fundName}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-md-2">
                  <label>Notes</label>
                </div>
                <div className="mb-3 col-md-4 w-25">
                  <textarea
                    className="form-control"
                    name="notes"
                    id="inputNotes"
                    onChange={handleNotes}
                  ></textarea>
                </div>
              </div>
              <div className="row pt-4">
                <div className="float-end text-end">
                  <button type="button" className="btn btn-link">
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={
                      amountValue.length === 0 && getBalance >= 0 ? true : false
                    }
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export { FundTransfer };
